import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=62a15c8e&scoped=true"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTable.vue?vue&type=style&index=0&id=62a15c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a15c8e",
  null
  
)

export default component.exports